var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.product_status === 'สินค้าหมด')?_c('div',{staticClass:"root"},[_vm._v(" สินค้าหมด ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }